/**
 * ч.1346: «Зведення банку» / «Зведення каси» — день за рахунком (як «Виписка банку» 1С).
 */
import { api } from './client';

export interface MoneyDayRow {
  document_type: string;
  document_id: string;
  kind_label: string;
  document_number: string;
  document_time: string | null;
  external_number: string | null;
  posted: boolean;
  party: string | null;
  income: string;
  expense: string;
  purpose: string | null;
  comment: string | null;
}

export interface MoneyDaySummary {
  kind: 'bank' | 'cash';
  date: string;
  organization_id: string;
  account_id: string;
  account_label: string;
  currency_code: string | null;
  ledger_note: string | null;
  opening: string;
  income: string;
  expense: string;
  closing: string;
  rows: MoneyDayRow[];
  unposted_count: number;
}

export const moneySummary = {
  bank: (params: { organization_id: string; bank_account_id: string; date: string }) =>
    api.get<MoneyDaySummary>('/money-summary/bank', { params }).then((r) => r.data),
  cash: (params: { organization_id: string; cash_register_id: string; date: string }) =>
    api.get<MoneyDaySummary>('/money-summary/cash', { params }).then((r) => r.data),
};
